import {PoolsState} from "@/store/settings/pools/types";
import {Module} from "vuex";
import {RootState} from "@/store/types";
import {actions} from "@/store/settings/pools/actions";
import {getters} from "@/store/settings/pools/getters";
import {mutations} from "@/store/settings/pools/mutations";

export const state: PoolsState = {
  pools: []
}

export const pools: Module<PoolsState, RootState> = {
  state,
  getters,
  actions,
  mutations
}